import React, { useState, useEffect } from "react";
import Datatable from "../Components/Datatable"
import { useTranslation } from 'react-i18next';
import axios from "axios";
import { useAuth } from '../../../../context/AuthContext';

function TeacherClassList() {
    const [data, setData] = useState([]);
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation()

    const columns = React.useMemo(
        () => [
            {
                Header: t('id'),
                Footer: t('id'),
                accessor: 'id', // accessor is the "key" in the data
            },
            {
                Header: t('className'),
                Footer: t('className'),
                accessor: 'className', // accessor is the "key" in the data
            },
            {
                Header: t('classdescription'),
                Footer: t('classdescription'),
                accessor: 'description',
            },
            {
                Header: t('teacherId'),
                Footer: t('teacherId'),
                accessor: 'lecturerId',
            },
            {
                Header: t('sectionId'),
                Footer: t('sectionId'),
                accessor: 'sectionId',
            },
            {
                Header: t('deleteclass'),
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex  align-items-center">

                        <button
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDelete(originalRow)}
                        >
                            {t('delete')}
                        </button>
                    </div>
                ),
                id: 'action',
                Footer: t('deleteclass'),
            },
            {
                Header: t('editclass'),
                accessor: (originalRow, rowIndex) => (
                    <div className="d-flex  align-items-center">
                        <button
                            className="btn btn-info btn-sm"
                            onClick={() => handleEdit(originalRow)}
                        >
                            {t('edit')}
                        </button>

                    </div>
                ),
                id: 'actionEditCourse',
                Footer: t('editclass'),
            },
        ],
        [],
    )


    const handleShowStudents = (row) => {
        window.location.href = "/teacher/studentlist/" + row['id'];
    }

    const handleEdit = (row) => {
        window.location.href = "/teacher/classsettings/" + row['id'];
    }
    const handleDelete = (row) => {
        // RequestHelper("/classes", "delete", "", row['id']).then(response => alert(response.statusText))
        window.location.reload();
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);

            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = "https://api.heryerdeingilizce.com/api/admin/Cupon/AllList";
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss
                }).then(res => {

                    if (res.status === 200) {
                        if (res.data['success']) {

                            for (let i = 0; i < res.data['data'].length; i++) {
                                let a = "";
                                if (res.data['data'][i]['isUsed']) {
                                    a = "kullanıldı";
                                }
                                else {
                                    a = "kullanılabilir";
                                }
                                data.push({

                                    "id": res.data['data'][i]['id'],
                                    "coupencode": res.data['data'][i]['cuponCode'],
                                    "coupendescription": res.data['data'][i]['cuponDescription'],
                                    "coupenexpiryDate": res.data['data'][i]['expiryDate'],
                                    "coupenpercentage": res.data['data'][i]['percentage'],
                                    "coupenusagelimit": res.data['data'][i]['usageLimit'],
                                    "coupenusage": a,

                                })
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }
        fetchData();

    }, []);

    return (
        <div style={{ backgroundColor: "white", width: "full" }} >
            <div style={{ textAlign: "center" }}>

                <h1>{t("classlist")}</h1>
                {loading && <div>Veriler Yüklenirken Bir Hata Meydana Geldi!</div>}
                {!loading && (
                    <div>
                        <Datatable data={data} columns={columns} tableBaslik={t("coupenlist")} />
                    </div>
                )}
            </div>

            <br />
        </div>
    );
}
export default TeacherClassList;
